<template>
  <div class="step" :class="{default:hasDefaultSlot}">
    <!-- Default Slot (Custom Step) -->
    <div v-if="hasDefaultSlot" class="default">
      <img class="logo" src="/images/bonobo-x-como.png" />
      <slot name="default" />
    </div>
    <!-- Step Template -->
    <template v-if="!hasDefaultSlot">
      <!-- Desktop -->
      <template v-if="desktop">
        <img class="logo" src="/images/bonobo-x-como.png" />
        <div class="guide-pane" :style="guidePaneStyle">
          <div class="step-number">step {{context.currentStep}}</div>
          <div class="title">
            <slot name="guideTitle" />
          </div>
          <p>
            <slot name="guideDescription" />
          </p>
          <img class="image" :src="image" />
        </div>
        <stepper :context="context" :horizontal="false" />
        <div class="form-pane">
          <div class="pad">
            <div class="title">
              <slot name="formTitle" />
            </div>
            <div class="form">
              <slot name="form" />
            </div>
            <div class="controls">
              <v-btn @click="$emit('back')">back</v-btn>
              <v-btn color="primary" @click="$emit('submit')">{{nextButtonText}}</v-btn>
            </div>
          </div>
        </div>
      </template>
      <!-- Mobile -->
      <template v-if="mobile">
        <div class="logo">
          <img src="/images/bonobo-x-como.png" />
        </div>
        <stepper :context="context" :horizontal="true" />
        <div class="scroll">
          <div class="guide-pane" :style="guidePaneStyle">
            <div class="step-number">step {{context.currentStep}}</div>
            <div class="title">
              <slot name="guideTitle" />
            </div>
            <p>
              <slot name="guideDescription" />
            </p>
            <img class="image" :src="image" />
          </div>
          <div class="form-pane">
            <div class="pad">
              <div class="title">
                <slot name="formTitle" />
              </div>
              <div class="form">
                <slot name="form" />
              </div>
              <div class="controls">
                <v-btn @click="$emit('back')">back</v-btn>
                <v-btn color="primary" @click="$emit('submit')">{{nextButtonText}}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import displayMixin from "@/mixins/display";
import Stepper from "./Stepper";

export default {
  props: ["context", "image"],
  mixins: [displayMixin],
  components: {
    Stepper
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
    nextButtonText() {
      return this.context.lastStep ? "finish" : "next step";
    },
    guidePaneStyle() {
      return {
        "--image": `url(${this.image})`
      };
    }
  }
};
</script>


<style lang="scss" scoped>
.step {
  width: 100%;
  max-width: 1291px;
  height: 846px;
  display: flex;
  position: relative;
  padding: 60px 40px;

  .title {
    font-size: 26px !important;
    color: #333d4d;
    font-weight: bold;
    font-family: "Open Sans" !important;
  }

  p {
    font-size: 14px;
    font-weight: 300;
    line-height: 1.71;
    color: #333d4d;

    b {
      font-weight: 600;
    }
  }

  .logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 234px;
  }

  .stepper {
    height: 55%;
    margin: auto;
  }

  .default {
    width: 100%;
  }

  /// GUIDE PANE
  .guide-pane {
    flex-shrink: 0;
    width: 495px;
    min-width: 495px;
    display: flex;
    flex-direction: column;
    margin: 22px 0;
    padding: 45px 53px 70px 55px;
    background-color: rgba(234, 240, 243, 0.4);

    .step-number {
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 1.31px;
      color: var(--v-primary-base);
      text-transform: uppercase;
      margin: auto;
    }

    .title {
      margin-top: 20px;
    }

    p {
      margin-top: 15px;
      flex: 1;
    }
  }

  // FORM PANE
  .form-pane {
    width: 100%;
    min-width: 650px;
    border: solid 4px #eaf0f3;
    border-left: none;
    padding: auto;

    .pad {
      width: 100%;
      max-width: 540px;
      margin: auto;
      margin-top: 105px;
      display: flex;
      flex-direction: column;

      > .form {
        flex: 1;
        margin: 20px 0;
        height: 450px;
      }

      > .controls {
        align-self: center;

        > *:not(:last-child) {
          margin-right: 55px;
        }
      }
    }
  }

  // MOBILE
  #app.mobile & {
    .default {
      height: 100%;
      overflow-y: overlay;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }

    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    max-height: 100%;
    height: 100%;
    padding: 0;

    > * {
      flex-shrink: 0;
    }

    .title {
      font-size: 24px !important;
    }

    .logo {
      position: initial;
      margin-top: 29px;
      margin-left: 24px;
      img {
        width: 120px;
      }
    }
    img.logo {
      width: 120px;
    }

    .stepper {
      position: initial;
      width: 90%;
      height: 25px;
      margin: 20px auto 0 auto;
    }

    .scroll {
      flex-direction: column;
      flex-grow: 1;
      flex: 1;
      overflow: overlay;
      -webkit-overflow-scrolling: touch;
      margin-top: 12px;
    }

    .guide-pane {
      width: 100%;
      min-width: auto;
      height: fit-content;
      margin: 0;
      padding: 25px;
      padding-top: 10px;
      background-color: inherit;
      position: relative;

      &::before {
        content: " ";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.25;
        background-image: var(--image);
        background-repeat: no-repeat;
        background-position: calc(100% + 65px) calc(100% + 15px);
        background-size: 220px;
      }

      .image {
        display: none;
      }
    }

    .form-pane {
      padding: 0 25px 40px 25px;
      flex-shrink: 0;
      border: none;
      min-width: 0;

      > .pad {
        margin: 0;
        max-width: 100%;
        > .form {
          height: inherit;
          margin: 15px 10px 25px 10px;
        }

        > .controls {
          display: flex;
          flex-direction: column-reverse;
          > * {
            margin: 0;
          }
          > *:not(:first-child) {
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
/// DEEP FORM STYLING TO BE INHERITED BY CHILDREN
::v-deep .form-pane > .pad > .form {
  /// CUSTOM CLASSES

  // inline
  .inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    max-width: 100%;

    font-size: 14px;
    font-weight: 600;
    line-height: 1.71;
    color: #696f89;

    > * {
      margin-right: 15px !important;
      flex-grow: 0;
      flex-shrink: 0;
    }

    &.disabled > *:not(.v-radio) {
      filter: invert(69%) sepia(17%) saturate(213%) hue-rotate(194deg)
        brightness(93%) contrast(91%);
    }
  }

  // hint
  .hint {
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: 0.3px;
    color: #696f89;
  }

  /// INPUT OVERRIDES
  // All inputs
  .v-input {
    position: relative;
    top: 1px;
    font-weight: 600;

    .v-input__control {
      max-width: 100%;
    }

    // Custom minimal
    @mixin minimal {
      height: 35px;
      padding: 0;
      margin: initial 0;

      .v-input__slot {
        width: 60px;
      }
    }
    &.minimal {
      @include minimal;
    }

    &.minimal-2 {
      @include minimal;
      .v-input__slot {
        width: 150px;
      }
    }
  }

  // Checkboxes
  .v-input--checkbox {
    margin: 0;
    margin-right: 10px;
    padding: 0;
    height: 35px;

    .v-label {
      left: 3px !important;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.71;
      letter-spacing: 0.08px;
      color: #333d4d;
    }

    .v-input__slot {
      height: 35px;
    }

    .v-input--selection-controls__input {
      margin-right: -3px;

      i {
        font-size: 18px;
      }
    }
  }

  // Text fields
  .v-text-field {
    .v-label {
      font-size: 12px;
      font-weight: 600;
      line-height: 2.18;
      letter-spacing: 0.08px;
      color: #696f89;
    }

    input {
      font-size: 14px;

      &::placeholder {
        opacity: 0.5;
        font-size: 13px;
        font-weight: 600;
        font-style: italic;
        line-height: 1.71;
        color: #a3a6b7;
      }
    }
    .v-text-field__prefix,
    .v-text-field__suffix {
      font-size: 14px;
    }

    .v-text-field__details {
      position: relative;
      top: -6px;
      min-height: 15px;
      .v-messages {
        .v-messages__message {
          font-size: 11px;
        }
      }
    }
  }

  // Select
  .v-select .v-select__selections {
    font-size: 14px;
    font-weight: 600;
  }

  // Radio groups
  .v-input--radio-group {
    // Row mode
    &--row {
      .v-input--radio-group__input > * {
        min-width: 138px;
      }
    }

    // Top label
    .v-input--radio-group__input > .v-label {
      width: 100%;
      font-size: 11px;
      font-weight: 600;
      line-height: 2.18;
      letter-spacing: 0.08px;
      color: #333d4d;
      margin-bottom: 4px;
    }

    // Radio buttons
    .v-radio {
      height: fit-content;
      margin: auto 10px auto 0;

      // Label
      .v-label {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.71;
        color: #a3a6b7;
      }
      &.v-item--active .v-label {
        color: #333d4d;
      }

      // Circle
      & .mdi-radiobox-blank.theme--light {
        color: #a3a6b7;
      }
    }
    &--column .v-radio {
      margin-bottom: 7px;
    }

    // Other inputs
    .v-input {
      margin: 0;
      padding: 0;

      // &.v-text-field > * {
      //   width: 250px;
      // }
    }
    &--row .v-input {
      position: relative;
      top: 11px;
    }

    // Custom hint
    &--row .hint {
      margin-top: 7px;
    }
    &--column .hint {
      margin-bottom: 15px;
    }
  }
}
</style>

